import { useMemo } from 'react';
import { useRecoilState } from 'recoil';
import yardList from 'recoil/atoms/yardList';
import { YardData, YardModel } from 'models/YardModel';
import Api from 'utils/api';
import { arrayGrouped, replaceItemAtIndex } from 'utils/common';


const useYards = () => {
    const [yards, setYards] = useRecoilState(yardList);

    const createYard = (yard: YardData) => Api.yards.create(yard)
        .then(res => setYards(old => [res.data.data, ...old]));

    const updateYard = (yard: YardModel) => Api.yards.update(yard)
        .then(res => {
            setYards(old => replaceItemAtIndex(old, old.findIndex(i => i.id === yard.id), res.data.data));
        });

    const yardsByPort = useMemo(() => {
        return arrayGrouped(yards, 'portId');
    }, [yards]);

    return {
        yards,
        yardsByPort,
        createYard,
        updateYard,
    }
};

export default useYards;
